/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Machine_CardInputs */

const vi_smartlab_settings_machine_card = /** @type {(inputs: Smartlab_Settings_Machine_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máy vò chè`)
};

/**

* @param {Smartlab_Settings_Machine_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_machine_card = /** @type {((inputs?: Smartlab_Settings_Machine_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Machine_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_machine_card(inputs)
});